<template>
  <b-modal
    id="org-details"
    centered
    hide-footer
    hide-header
    @show="reset"
    @hidden="reset"
  >
    <h3 class="mb-3">Edit Organization</h3>
    <form @submit.prevent="save">
      <NanInput
        v-model="form.name"
        label="Organization Name"
        placeholder="Nanome"
        class="mb-3"
        autofocus
      />

      <NanInput
        v-if="$store.getters.hasPermission('org.edit')"
        v-model="form.hubspot_id"
        label="Hubspot ID"
        placeholder="000000000"
        class="mb-3"
      />

      <div class="mt-4 text-right">
        <b-btn
          class="ml-2 px-4"
          variant="secondary"
          @click="$bvModal.hide('org-details')"
        >
          Cancel
        </b-btn>
        <b-btn class="ml-2 px-4" variant="primary" type="submit">
          Update
        </b-btn>
      </div>
    </form>
  </b-modal>
</template>

<script>
import API from "@/api";

export default {
  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    form: {
      name: "",
      hubspot_id: ""
    }
  }),

  methods: {
    reset() {
      this.form.name = this.org.name;
      this.form.hubspot_id = this.org.hubspot_id;
    },

    async save() {
      const { name, hubspot_id } = this.form;
      const { success } = await API.editOrg(this.org.id, name, hubspot_id);
      if (!success) return;

      this.$emit("updated");
      this.$notify({
        type: "success",
        text: "Organization details updated"
      });
    }
  }
};
</script>
